import React from 'react';
import { articles } from './ArticleCard'; 
const ArticleContent = () => {
    const article3 = articles[2];
    return (
        <div className="text-2xl max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-20">
            <h1 className='font-bold'>{article3.title}</h1>
            <div 
                style={{
                    width: '60%',
                    height: '60%',
                    overflow: 'hidden',
                    margin: '40px auto'
                }}
                className="my-10"
            >
                <img 
                    src={article3.photoCover33} 
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center center',
                    }} 
                />
            </div>
            <p className='mb-10'>{article3.contentP1}</p>
            <p className='mb-10'>{article3.contentP2}</p>
            <p className='mb-10'>{article3.contentP3}</p>
            <p className='mb-10'>{article3.contentP4}</p>
            <p className='mb-10'>{article3.contentP5}</p>
            <p className='mb-10'>{article3.contentP6}</p>
            <p className='mb-10'>{article3.contentP7}</p>
            <p className='mb-10'>{article3.contentP8}</p>
            <p className='mb-10'>{article3.contentP9}</p>
        </div>
    );
};

export default ArticleContent;
